module.exports = __webpack_public_path__ + "static/media/Madfit-9.5cf39056.jpg";